import React, {useContext, useEffect, useState} from "react";

import Carosel from "../../../components/Carousel";

import Bubble from '../../../assets/icons/icon_bubble.png';
import { backIncstance } from "../../../utils/commonFunctions";
import {MyContext} from "../../../context/MyContext";

const CUSTOM_SOCRATES = `영재교육원, 영재학교, 대학 등의 심층 면접을 과학동아AiR로 준비하세요!\n관심 키워드와 실험 보고서, 자기소개서 등 활동자료를 입력하면 맞춤형 질문을 받아 볼 수 있어요.\n실전처럼 면접을 보고, 평가 리포트를 받아보세요.\n※평가 리포트는 끝까지 완료한 면접만 받아볼 수 있어요.
`

const URLS = {
  CATEGORY_LIST: process.env.REACT_APP_SOCRATES_CATEGORY,
  PROMPT_MSG: process.env.REACT_APP_PROMPT,
  GREETING_MSG: process.env.REACT_APP_GREETING_MSG
}


const Home = props => {

  const { selectInterviewMode, startInterview } = props;
  const {setAlertSetting} = useContext(MyContext);

  const [samples, setSamples] = useState([]) // 모의 면접

  const [welcomeMsg, setWelcomeMsg] = useState('');

  const touchAPI = async (method, url, data) => {
    try {
      const response = await backIncstance(method, url, data)
      const resData = await response?.json()
      if (!resData) return
      if (url.includes(URLS.CATEGORY_LIST)) {
        setSamples(resData.category_list)
      } else if (url.includes(URLS.GREETING_MSG)) {
        setWelcomeMsg(resData.greeting)
      } else if (url.includes(URLS.PROMPT_MSG)) {

      }

    } catch (err) {
      setAlertSetting(prev => ({
        ...prev,
        alertTxt: `서버 오류입니다.\n관리자에게 문의 바랍니다.`,
        btnTxt: '닫기'
      }));
    } finally {
    }

  }

  useEffect(() => {
    const url = `${URLS.PROMPT_MSG}?kind=socra`
    touchAPI('GET', url)
    const welcomeUrl = `${URLS.GREETING_MSG}?kind=socra`
    touchAPI('GET', URLS.CATEGORY_LIST)
    touchAPI('GET', url)
    touchAPI('GET', welcomeUrl)
  }, [])
  return (
    <>
      <div className="emp-box flx-box sep-elm socrates">
        <div className="emp-box__top md:min-h-[424px]" style={{ textAlign: 'initial' }}>
          <p className="title" >{welcomeMsg}<h1 className="socra-title">{` 소크라테스‍‍ 👨‍🎓`}</h1></p>
          <div className="flx-box bubble-wrp">
            <img src={Bubble} alt="icon_bubble" />
            <p className="bubble-txt">소크라테스가 처음인가요? 체험해 보세요.</p>
          </div>
          {
            samples.length > 0 &&
            <Carosel slides={samples} socrates handleClick={selectInterviewMode} />
          }
        </div>
        <div className="division"></div>
        <div className="emp-box__btm">
          <h1>나만의 AI면접관 ‘소크라테스’를 직접 만들어요.</h1>
          <div className="flx-box sep-elm responsive-box">
            <div className="desc" style={{ whiteSpace: 'break-spaces', lineHeight: '1.5rem' }}>{CUSTOM_SOCRATES}</div>
            <div className="add_custom_btn crs-btn flx-box" onClick={startInterview}>
              <p>✍️ 나만의 소크라테스 만들기</p>
            </div>
          </div>

        </div>
        <p className="copyright-txt">*특허출원 : 과학 지식 기반 인공지능 모의 면접 플랫폼 (출원번호 10-2024-0117975)</p>
      </div>
    </>

  )
}

export default Home
